import { CSSResultArray } from 'lit';
import { customElement } from 'lit/decorators.js';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';
import componentStyles from './pc-inquiries-hero.css.lit';

import globalStyles from './pc-inquiries-hero.lightDom.css.lit';
import { PCBaseLayout } from '../pc-base-layout/pc-base-layout';

/**
 * Media Inquiries Hero component
 * @element pc-inquiries-hero
 */
@customElement('pc-inquiries-hero')
export class PCInquiriesHero extends PCBaseLayout {
  static styles: CSSResultArray = [componentStyles];
  adoptedStylesheets: AdoptedStyleSheets;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-inquiries-hero': PCInquiriesHero;
  }
}
